import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../api/client.jsx';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';
import { useApiMutation } from '../../api/mutations';
import { subscriptionsFixture, cancelSubscriptionFixture } from './fixture';

export function useSubscriptions(params = {}) {
  const { fetch } = useApiClient();
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['subscriptions', params, fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) {
        await fixtureDelay();
        return subscriptionsFixture(params);
      }
      const qs = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => v && qs.set(k, v));
      return fetch(`/v1/admin/subscriptions?${qs.toString()}`);
    },
  });
}

export function useCancelSubscription() {
  return useApiMutation({
    live: (fetch, { id, immediate, reason }) =>
      fetch(`/v1/admin/subscriptions/${id}/cancel`, {
        method: 'POST',
        body: { immediate, reason },
      }),
    fixture: ({ id }) => cancelSubscriptionFixture({ id }),
    invalidate: ['subscriptions'],
    successMessage: 'Subscription gekündigt.',
  });
}
